<template>
  <CdrInput
    v-model="listName"
    class="create-wishlist__input"
    :error="error"
    :label="label"
    data-ui="list_name"
    @input="(e) => runValidation(e)"
    @blur="(e) => runValidation(e)"
  />
</template>

<script>
import { CdrInput } from '@rei/cedar';
import { validateInput } from '../../common/utils';

export default {
  name: 'ListNameComponent',
  components: {
    CdrInput,
  },
  props: {
    name: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      required: true,
    },
    error: {
      type: String,
      required: false,
      default: null,
    },
  },
  data() {
    return {
      listName: this.name,
    };
  },
  watch: {
    listName: function emptyNameWatcher() {
      if (!this.listName) {
        this.$emit('input-is-empty');
      }
    },
  },
  methods: {
    runValidation(event) {
      const isValidInput = validateInput(event.target.value);
      this.$emit('set-name-valid', isValidInput);
      this.$emit('set-name', event.target.value);
    },
  },
};
</script>

<style lang="scss">
.create-wishlist__input {
  max-width: 350px;
  width: 100%;
}
</style>
